module.exports = __webpack_public_path__ + "agency-academy.6e45e38b713dbd8855e8.png";